import frDashboard from './dashboard/dashboard.json'
import frStats from './stats/stats.json'
import frAccreditation from './accreditation/accreditation.json'
import frCms from './cms/cms.json'
import frAuth from './auth/auth.json'
import frCommon from './common/common.json'
import frCompetition from './competition/competition.json'
import frGeneralApplications from './general-applications/general-applications.json'
import frLeague from './league/league.json'
import frMatch from './match/match.json'
import frNotification from './notification/notification.json'
import frOrganization from './organization/organization.json'
import frPhase from './phase/phase.json'
import frRecreation from './recreation/recreation.json'
import frRoles from './roles/roles.json'
import frSeason from './season/season.json'
import frShared from './shared/shared.json'
import frSponsor from './sponsor/sponsor.json'
import frSport from './sport/sport.json'
import frUnit from './unit/unit.json'
import frUser from './user/user.json'
import frUtils from './utils/utils.json'

export const fr = {
    dashboard: frDashboard,
    stats: frStats,
    common: frCommon,
    accreditation: frAccreditation,
    notification: frNotification,
    sponsor: frSponsor,
    league: frLeague,
    roles: frRoles,
    season: frSeason,
    unit: frUnit,
    user: frUser,
    organization: frOrganization,
    sport: frSport,
    shared: frShared,
    competition: frCompetition,
    'general-applications': frGeneralApplications,
    utils: frUtils,
    phase: frPhase,
    auth: frAuth,
    match: frMatch,
    recreation: frRecreation,
    cms: frCms,
}
